import branchDlg from "./branchDlg.js";
import branchDlgMul from "./branchDlgMul.js";
import supportPostDlg from "./supportPostDlg.js";
import permissionDlg from "./permissionDlg.js";
import permissionDlgMul from "./permissionDlgMul.js";
import userDlgMul from "./userDlgMul.js";

const platformMan = {
  namespaced: true,
  modules: {
    branchDlg,
    branchDlgMul,
    supportPostDlg,
    permissionDlg,
    permissionDlgMul,
    userDlgMul
  }
};

export default platformMan;
